import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import ImageHero from 'components/Common/ImageHero'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import OfferTypesCarousel from 'home/components/BrowseOfferTypes/OfferTypesCarousel'
import TextButton from 'LuxKit/Button/TextButton'

const StyledHeroImage = styled(ImageHero)`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  max-height: ${rem(300)};
`

const Section = styled(LayoutContainer)`
  padding: 0 ${rem(20)};
`

const ContentWrapper = styled.div`
  ${mediaQueryUp.tablet} {
    width: 75%;
  }
`

const OfferTypeCarouselWrapper = styled.div`
  padding-top: ${rem(44)};
  padding-bottom: ${rem(24)};

  ${mediaQueryUp.tablet} {
    padding-top: ${rem(84)};
    padding-bottom: ${rem(40)};
  }
`

function CompetitionClosedPage() {
  const intl = useIntl()

  const closedHeading = intl.formatMessage({
    id: 'AW06A9vvVYTnbx7Wx0lD',
    defaultMessage: 'Sorry, this competition has now closed',
    description: 'Hero heading shown when a competition has ended on the marketing page',
  })
  const discoverHeading = intl.formatMessage({
    id: 'QpPTA2NPehTiCO5A7kPT',
    defaultMessage: 'This competition may be over, but you can still discover your dream escape.',
    description: 'Subheading encouraging users to explore offers after competition closes',
  })
  const discoverBody = intl.formatMessage({
    id: 'dPfXxf52VgIH3Jan7qCd',
    defaultMessage: 'Explore our exclusive offers for stunning stays, unforgettable experiences, incredible cruises and curated tours. Discover more of the world’s best holidays now.',
    description: 'Description text encouraging users to browse travel offers after competition closes',
  })
  const viewOffersLabel = intl.formatMessage({
    id: 'gGOHyQ8lrRH1UApwkR7s',
    defaultMessage: 'View today’s exclusive offers',
    description: 'Button text linking to homepage offers after competition closes',
  })
  const everythingTravelHeading = intl.formatMessage({
    id: 'InIqQIwtnT1zolpdL_0j',
    defaultMessage: 'Everything travel, all in one place',
    description: 'Heading for offer types carousel on competition closed page',
  })

  return (
    <Pane>
      <Group direction="vertical" tabletGap={56} gap={40}>
        <StyledHeroImage
          alt="competitions-closed-image"
          aria-hidden="true"
          id="0xt33ors70wfjjhxcmf"
          mobileAspectRatio="2:1"
          tabletAspectRatio="2:1"
          desktopAspectRatio="7:2"
          largeDesktopAspectRatio="5:1"
          brightness={-25}
        >
          <Section size="lg">
            <Heading variant="heading2" colour="neutral-eight" align="center">
              {closedHeading}
            </Heading>
          </Section>
        </StyledHeroImage>
        <Section size="lg">
          <ContentWrapper>
            <VerticalSpacer gap={24}>
              <VerticalSpacer gap={8}>
                <Heading variant="heading3">
                  {discoverHeading}
                </Heading>
                <BodyText variant="large" colour="neutral-two">
                  {discoverBody}
                </BodyText>
              </VerticalSpacer>
              <TextButton kind="primary" to="/">
                {viewOffersLabel}
              </TextButton>
            </VerticalSpacer>
          </ContentWrapper>
        </Section>
      </Group>
      <OfferTypeCarouselWrapper>
        <VerticalSpacer gap={20}>
          <Section size="lg">
            <Heading variant="heading3">
              {everythingTravelHeading}
            </Heading>
          </Section>
          <OfferTypesCarousel />
        </VerticalSpacer>
      </OfferTypeCarouselWrapper>
    </Pane>
  )
}

export default CompetitionClosedPage
